import React, { useEffect } from "react";
import * as echarts from "echarts";
import { Font } from "@react-pdf/renderer";
import { FormatMoney } from "../../../Helpers/FormatNumber";

export const EstadoResultadosChart = ({ name, data, filtrado }) => {
    const includeGrupo = filtrado === "adr";
    useEffect(() => {
        if (!data.data || data.data.length === 0) return;
        const dom = document.getElementById(name);
        const myChart = echarts.init(dom, null, {
            renderer: "canvas",
            useDirtyRect: false,
        });

        // console.log(filtrado)

        const option = {
            tooltip: {
                trigger: "item",
                formatter: function (params) {
                    const categoryName = params.name;
                    const seriesLabel = params.seriesName;
                    const value = params.value;

                    const formattedValue = Array.isArray(value)
                        ? FormatMoney(value[params.seriesIndex + 1])
                        : FormatMoney(value);

                    return `
                <b>${categoryName}</b><br/>
                ${seriesLabel}: ${formattedValue}
              `;
                }
            },
            legend: {
                orient: "horizontal", // Dirección horizontal
                bottom: 5,             // Posición en la parte inferior
              },
              
            dataset: {
                source: [
                    ["product", "Actual", "Proyectado", "Anterior"],
                    ...(filtrado === "adr"
                        ? [["Grupo", data.totales.total, data.totales.proyectado, data.totales.totallast]]
                        : []),

                    ...data.data.map((item) => [
                      item.display,
                      item.total,
                      item.proyectado,
                      item.totallast,
                    ]),
                  ],
            },
            xAxis: {
                type: "category",
                axisLabel: {
                    interval: 0,
                    rotate: 0,
                    fontSize: 10
                }
            },
            yAxis: {},
            series: [{ type: "bar" }, { type: "bar" }, { type: "bar" }],
            grid: {
                left: 40,
                right: 40,
                top: 35,
                bottom: 30,
                containLabel: true
            },
        };



        myChart.setOption(option);

        // Redimensionar el gráfico cuando cambie el tamaño de la ventana
        window.addEventListener("resize", () => {
            myChart.resize();
        });

        // Limpiar el gráfico al desmontar el componente
        return () => {
            window.removeEventListener("resize", () => {
                myChart.resize();
            });
            myChart.dispose();
        };
    }, [data.data]);

    return <div id={name} style={{ width: "100%", height: "300px" }}></div>;
};
